module.exports = __webpack_public_path__ + "img/SpielohneGrenzenHeerstedt.b29ae5d2.jpg";